import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { getBookedFdaDisplayName } from "@capone/common";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const ADD_ONS_TITLE = "Add-ons";
export const CFAR_TITLE = "Cancel for any reason";
export const CFAR_BUTTON_ARIA_TEXT = "Open cancel-for-any-reason modal";
export const getDisruptionProtectionTitle = (productVariant?: string) =>
  getBookedFdaDisplayName(productVariant);

export const CHFAR_TITLE = "Change your flight for any reason";
export const CHFAR_BUTTON_ARIA_TEXT = "Navigate to change-for-any-reason page";

export const DISRUPTION_PROTECTION_BUTTON_ARIA_TEXT =
  "Open flight disruption assistance modal";

export const EXPIRY_DATE_COPY = (date: string, tz: string): string => {
  const timezone = tz === "Z" ? "UTC" : tz;
  return `Expires on ${dayjs(date).tz(timezone).format("MMM DD, h:mm A z")}`;
};
